import { parseJsonObject } from "../../../features/builder.utils";
import { handlerOf } from "./channel.utils";

const wholeNumber = (value, min, max, label) => {
  if (value === "" || value === null || value === undefined) return "";
  const number = Number(value);
  return Number.isInteger(number) && number >= min && number <= max ? "" : `${label} must be a whole number from ${min} to ${max}.`;
};

// Mirrors RemChannelCtl.normalize in the backend (reminder_setup/channel/controller.js).
export const channelValidation = {
  channel_key: (value, formData, dependencies) => {
    const handler = handlerOf({ channel_key: value }, dependencies);
    return !formData.id && handler?.channel_fid ? "This channel is already set up; edit it instead." : "";
  },
  name: (value) => (String(value ?? "").trim().length > 100 ? "Name must be at most 100 characters." : ""),
  rate_limit_per_min: (value) => wholeNumber(value, 1, 100000, "Rate limit"),
  sort_order: (value) => wholeNumber(value, 0, 10000, "Sort order"),
  template_schema_text: (value, formData, dependencies) => {
    if (!formData.edit_schemas) return "";
    const schema = parseJsonObject(value ?? "");
    if (!schema) return "Template schema must be a JSON object.";
    const required = handlerOf(formData, dependencies)?.template_schema?.required ?? [];
    return required.every((key) => schema.properties?.[key]) ? "" : `Keep ${required.join(", ")} in the properties.`;
  },
  config_schema_text: (value, formData) => (formData.edit_schemas && parseJsonObject(value ?? "") === undefined ? "Config schema must be a JSON object, or empty." : ""),
};
